<template>
  <div class="tender-summary-wrapper">
    <div class="tender-info__container">
      <div v-if="isIncomingTenderPage($route) && offerCanBeAdded" class="tender-info-block">
        <IncomingOfferActions />
      </div>
      <div
        id="tender-summary-content"
        class="tender-summary-content tender-summary-content_incoming spacey-12"
      >
        <div class="tender-summary-base-block">
          <router-view />
        </div>
      </div>
    </div>
    <div class="tender-summary-chat-block">
      <Chat />
    </div>
  </div>
</template>

<script>
  import Chat from '@/containers/chat/Chat';
  import { isIncomingTenderPage } from '@/utils/route-matcher';
  import IncomingOfferActions from '@/containers/incoming-tender/OfferActions';
  import { mapGetters } from 'vuex';

  export default {
    name: 'TenderSummary',
    components: {
      Chat,
      IncomingOfferActions,
    },
    computed: {
      ...mapGetters('incomingTender', ['offerCanBeAdded']),
    },
    methods: {
      isIncomingTenderPage,
    },
  };
</script>
